// extracted by mini-css-extract-plugin
var _1 = "AITextGenerationFormFieldsSettings-moduleavatar__E2IIs AILengthDropdownItemContent-moduleavatar__B4Ex9 SelectEntityItemAvatar-moduleavatar__zeGPU";
var _2 = "AITextGenerationFormFieldsSettings-modulecheckbox__GFaOR AICheckbox-moduleaiCheckbox__Bll6O";
var _3 = "AITextGenerationFormFieldsSettings-modulecheckboxLabel__DV5JM";
var _4 = "AITextGenerationFormFieldsSettings-modulecheckboxLabelTitle__H3hpL";
var _5 = "AITextGenerationFormFieldsSettings-moduleselect__zu0h4";
var _6 = "AITextGenerationFormFieldsSettings-modulesettings__HfyNg";
var _7 = "AITextGenerationFormFieldsSettings-modulesettingsDisabled__BvKdb";
export { _1 as "avatar", _2 as "checkbox", _3 as "checkboxLabel", _4 as "checkboxLabelTitle", _5 as "select", _6 as "settings", _7 as "settingsDisabled" }
